import type { FC } from 'react'
import { ExpandImageButton } from '@/components/commons/expand-image-button'
import { ImageCard } from '@/components/commons/image-card'
import { EditingQaFlagsSelector } from '@/features/photoset/components/editing-qa-flags-selector'
import { SpaceImagesContainer } from '@/features/photoset/components/space-images-atoms'
import { usePhotosetStore } from '@/features/photoset/store/store'
import type { Image } from '@/features/photoset/types'

interface EditingQaFlagsSpaceImagesProps {
	images: Omit<Image, 'space'>[]
	isQaView: boolean
	spaceId: number
	spaceIndex: number
	onExpandImage: (spaceIndex: number, imageIndex: number) => void
}

export const EditingQaFlagsSpaceImages: FC<EditingQaFlagsSpaceImagesProps> = ({
	images,
	spaceId,
	isQaView,
	spaceIndex,
	onExpandImage
}) => {
	const selectedImages = usePhotosetStore((state) => state.selectedImages)
	const selectImages = usePhotosetStore((state) => state.selectImages)
	const unselectImages = usePhotosetStore((state) => state.unselectImages)

	return (
		<SpaceImagesContainer>
			{images.map((image, index) => {
				const isSelected = selectedImages.some(
					(selectedImageId) => selectedImageId === image.id
				)
				return (
					<ImageCard
						endSlot={
							<>
								<ExpandImageButton
									onClick={() =>
										onExpandImage(spaceIndex, index)
									}
								/>
								<EditingQaFlagsSelector
									image={image}
									isQaView={isQaView}
									photosetSpaceId={spaceId}
								/>
							</>
						}
						hideCheckbox
						hideImageInfo={false}
						image={image}
						isSelected={isSelected}
						key={image.id}
						onSelect={
							isQaView
								? () =>
										isSelected
											? unselectImages([image.id])
											: selectImages([image.id])
								: null
						}
						thumbnail={image.thumbnails?.xs}
					/>
				)
			})}
		</SpaceImagesContainer>
	)
}
